
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire545f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire545f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("jc90N", function(module, exports) {
module.exports = new URL("output.54132bce.css", import.meta.url).toString();

});

parcelRegister("aw8wR", function(module, exports) {
module.exports = new URL("brand.3bc21133.css", import.meta.url).toString();

});

var $770f1afbe5a8f0f2$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9sXZ0","index.b0b4a3c0.js","hKZ6m","style.7d1d36f1.css","hEH4t","output.54132bce.css","fLoJN","brand.3bc21133.css","aKdi3","index.93956a0c.js"]'));


var $jJTNo = parcelRequire("jJTNo");
var $da88be49badd8b4e$exports = {};
$da88be49badd8b4e$exports = new URL("style.7d1d36f1.css", import.meta.url).toString();



var $jc90N = parcelRequire("jc90N");

var $aw8wR = parcelRequire("aw8wR");
class $f9c3c31430993d7a$var$UpdatesBanner extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: "open"
        });
    }
    static get observedAttributes() {
        return [];
    }
    attributeChangedCallback() {
        this.render();
    }
    connectedCallback() {
        this.getBannerContent();
    }
    closeBanner() {
        const overlay = this.shadow.querySelector(".banner-overlay");
        if (overlay) overlay.remove();
    }
    async getBannerContent() {
        try {
            const response = await fetch(`/announcements`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            if (data) {
                const active = data.active;
                const message = data.message;
                const linkText = data.linkText;
                const linkHref = data.linkHref;
                if (active) {
                    this.render();
                    const bannerContent = `${message} <a href="${linkHref}" target="_blank" class="whitespace-nowrap font-semibold">${linkText}&nbsp;<span aria-hidden="true">&rarr;</span></a>`;
                    this.shadow.querySelector("#bannerMessage").innerHTML = bannerContent;
                    const bannerClose = this.shadow.querySelector("#bannerClose");
                    bannerClose.addEventListener("click", ()=>this.closeBanner());
                }
            }
        } catch (error) {
            console.error("Error:", error);
            return false;
        }
    }
    render() {
        const template = (0, $jJTNo.html)`
      <link
        href="https://fonts.googleapis.com/css2?family=Orbitron:wght@400;900&display=swap"
        rel="stylesheet"
      />
      <link href="${$jc90N}" rel="stylesheet">
      <link href="${$da88be49badd8b4e$exports}" rel="stylesheet">
      <link href="${$aw8wR}" rel="stylesheet">
      <div class="relative isolate flex items-center gap-x-6 overflow-hidden px-6 py-2.5 sm:px-3.5 sm:before:flex-1 banner-overlay">
        <p id="bannerMessage" class="text-sm leading-6 text-white future-font">
        </p>
        <div class="flex flex-1 justify-end">
          <button id="bannerClose" type="button" class="-m-3 p-3 focus-visible:outline-offset-[-4px]">
            <span class="sr-only">Dismiss</span>
            <svg class="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
          </button>
        </div>
      </div>
    `;
        (0, $jJTNo.render)(template, this.shadow);
    }
}
customElements.define("updates-banner", $f9c3c31430993d7a$var$UpdatesBanner);


parcelRequire("bgeJJ");
parcelRequire("l2CVb");
document.addEventListener("DOMContentLoaded", ()=>{
    const queryParams = new URLSearchParams(window.location.search);
    const accessDeniedMessage = "Access Denied: Please subscribe for access to all our awesome online content or go to the invite page to add the code from your Vanguard Commander!";
    if (queryParams.get("error")) {
        const decodedError = decodeURIComponent(queryParams.get("error"));
        if (decodedError.includes("access_denied")) {
            $761f97bf09d51d3e$var$showFuturisticAlert(accessDeniedMessage);
            window.history.replaceState({}, "", window.location.pathname);
        }
    }
});
document.getElementById("slide-over-close-button").addEventListener("click", function(event) {
    event.stopPropagation();
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-back").addEventListener("click", function(event) {
    event.stopPropagation();
    $761f97bf09d51d3e$var$addHiddenClass();
});
function $761f97bf09d51d3e$var$addHiddenClass() {
    document.getElementById("slide-over-panel").classList.add("hidden");
    document.getElementById("slide-over-back").classList.add("hidden");
}
document.getElementById("slide-over-link-1").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-2").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-3").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-4").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-5").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-6").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-7").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-8").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-9").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-10").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("slide-over-link-11").addEventListener("click", function() {
    $761f97bf09d51d3e$var$addHiddenClass();
});
document.getElementById("side-nav").addEventListener("click", function(event) {
    event.stopPropagation();
    document.getElementById("slide-over-panel").classList.remove("hidden");
    document.getElementById("slide-over-back").classList.remove("hidden");
});
function $761f97bf09d51d3e$var$showFuturisticAlert(message) {
    const overlay = document.createElement("div");
    overlay.className = "alert-overlay";
    const alert1 = document.createElement("div");
    alert1.className = "futuristic-alert";
    alert1.innerHTML = `
    <div class="alert-content">${message}</div>
    <div class="alert-buttons">
      <button class="alert-button">OK</button>
    </div>
  `;
    document.body.appendChild(overlay);
    document.body.appendChild(alert1);
    const closeAlert = ()=>{
        overlay.remove();
        alert1.remove();
    };
    const button = alert1.querySelector("button");
    button.addEventListener("click", closeAlert);
    overlay.addEventListener("click", (event)=>{
        if (event.target === overlay) closeAlert();
    });
}
document.getElementById("faq-button-0").addEventListener("click", function() {
    document.getElementById("faq-0").classList.toggle("hidden");
    document.getElementById("faq-0-plus").classList.toggle("hidden");
    document.getElementById("faq-0-minus").classList.toggle("hidden");
});
document.getElementById("faq-button-1").addEventListener("click", function() {
    document.getElementById("faq-1").classList.toggle("hidden");
    document.getElementById("faq-1-plus").classList.toggle("hidden");
    document.getElementById("faq-1-minus").classList.toggle("hidden");
});
document.getElementById("faq-button-2").addEventListener("click", function() {
    document.getElementById("faq-2").classList.toggle("hidden");
    document.getElementById("faq-2-plus").classList.toggle("hidden");
    document.getElementById("faq-2-minus").classList.toggle("hidden");
});
document.getElementById("faq-button-3").addEventListener("click", function() {
    document.getElementById("faq-3").classList.toggle("hidden");
    document.getElementById("faq-3-plus").classList.toggle("hidden");
    document.getElementById("faq-3-minus").classList.toggle("hidden");
});
document.getElementById("faq-button-4").addEventListener("click", function() {
    document.getElementById("faq-4").classList.toggle("hidden");
    document.getElementById("faq-4-plus").classList.toggle("hidden");
    document.getElementById("faq-4-minus").classList.toggle("hidden");
});
document.getElementById("faq-button-5").addEventListener("click", function() {
    document.getElementById("faq-5").classList.toggle("hidden");
    document.getElementById("faq-5-plus").classList.toggle("hidden");
    document.getElementById("faq-5-minus").classList.toggle("hidden");
});
document.getElementById("contact-form").addEventListener("submit", function(event) {
    event.preventDefault();
    const formData = new FormData(this);
    fetch("/contact", {
        method: "POST",
        body: new URLSearchParams(formData)
    }).then((response)=>{
        if (response.ok) {
            this.reset();
            alert("Your message has been sent successfully!");
        } else alert("There was an error sending your message. Please try again later.");
    }).catch((error)=>{
        alert(`There was a problem with the server. Please try again later.\n Error: ${error}`);
    });
});


//# sourceMappingURL=index.b0b4a3c0.js.map
